export const DATEFORMAT = {
  DATE_TIME: 'DD/MM/YYYY HH:mm',
  FULL_TIME: 'DD/MM/YYYY - HH:mm:ss',
  DATE: 'DD/MM/YYYY'
}
